import { render, staticRenderFns } from "./LexonFileUploadComponent.vue?vue&type=template&id=46c7fa28&scoped=true&lang=pug"
import script from "./LexonFileUploadComponent.vue?vue&type=script&lang=ts"
export * from "./LexonFileUploadComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonFileUploadComponent.vue?vue&type=style&index=0&id=46c7fa28&lang=scss"
import style1 from "./LexonFileUploadComponent.vue?vue&type=style&index=1&id=46c7fa28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7fa28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c7fa28')) {
      api.createRecord('46c7fa28', component.options)
    } else {
      api.reload('46c7fa28', component.options)
    }
    module.hot.accept("./LexonFileUploadComponent.vue?vue&type=template&id=46c7fa28&scoped=true&lang=pug", function () {
      api.rerender('46c7fa28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonFileUpload/LexonFileUploadComponent.vue"
export default component.exports